var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return [(_vm.post)?_c('div',{staticClass:"blog-post"},[_c('h1',[_vm._v(_vm._s(_vm.post.Name))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.post.Content)}}),_c('Navigation',{attrs:{"mode":"simple"}})],1):_vm._e()]}
var staticRenderFns = []

export { render, staticRenderFns }